import React from 'react';
import { Row, Col } from 'antd';
import P from '../../../../components/P';
import startCase from 'lodash/startCase';
import { penceAsPounds } from '$app/core/utils/dataTableRenderers';

export let ExpandedRecord = (record) => {

  const renderChanges = changes => {
    const keys = Object.keys(changes);
    return keys.map((key, idx) => {
      if (key === 'masterStatus') {
        return <p key={idx}>Master Status Name: {changes.masterStatus.masterStatusName}</p>;
      } else if (key === 'pence' || key === 'garageTotalPrice') {
        return <p key={idx}>{startCase(key)}: {penceAsPounds(changes[key], 'display')}</p>;
      } else if (key === 'jobInvitationLineItems') {
        // this looks disable on the Be didnt find any booking with it on dev
        return null;
      } else {
        return <p key={idx}>{startCase(key)}: {JSON.stringify(changes[key])}</p>;
      }
    });
  };

  const renderPrevious = (changes, oldState) => {
    const keys = Object.keys(changes);
    return keys.map((key, idx) => {
      if (oldState[key]) {
        if (key === 'masterStatus') {
          return <p key={idx}>Master Status Name: ${oldState.masterStatus.masterStatusName}</p>;
        } else if (key === 'pence') {
          return <p key={idx}>Total Price: ${penceAsPounds(oldState[key], 'display')}</p>;
        } else if (key === 'garageTotalPrice') {
          return <p key={idx}>${startCase(key)}: ${penceAsPounds(oldState[key], 'display')}</p>;
        } else {
          return <p key={idx}>${startCase(key)}: ${JSON.stringify(oldState[key])}</p>;
        }
      }
    });
  };

  return (
    <div>
      <Row>
        <P>Author: {record.author}</P>
        <P>Comment: {record.comment}</P>
      </Row>
      <Row>
        <Col style={{ padding: '5px 0' }} span={12}>
          <P>Prev. state</P>
          <hr/>
          <ul>{renderPrevious(record.changes, record.oldState) || ''}</ul>
        </Col>
        <Col style={{ padding: '5px 0' }} span={12}>
          <P>Changes</P>
          <hr/>
          <ul>{renderChanges(record.changes) || ''}</ul>
        </Col>
      </Row>
    </div>
  );
};
